// +----------------------------------------------------------------------
// | Desc:路径库(路径组合、接口请求、链接跳转等)
// +----------------------------------------------------------------------
import Vue from "vue";

// +----------------------------------------------------------------------
// | EXCEL下载器
// +----------------------------------------------------------------------
Vue.prototype.$downLoad = function (api, parameter, fileName) {
  var config = this.$configBase();
  var that = this;
  var token = localStorage.getItem("token");
  if (this.$isblank(token)) {
    var token = sessionStorage.getItem("token");
  }
  if (this.$isblank(token)) {
    this.$msg("登录信息过期", "warning");
    return;
  }
  parameter["token"] = token;
  var url = config.api + api + "?parm=" + this.$encrypt(JSON.stringify(parameter));
  this.$loading(true, "下载中...");
  var xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.responseType = "blob";
  xhr.onload = function () {
    console.log(xhr);
    if (this.status == 200) {
      var blob = this.response;
      // 创建下载链接
      var a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = fileName;
      // 模拟点击下载
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      URL.revokeObjectURL(a.href);
      that.$loading(false);
      that.$msg("下载成功,请在目录查看", "success");
    }
  };
  xhr.send();
};